import appSettings from "../settings/appSettings";
import fetchRequest from "./fetchRequest";
import { servicesClient } from "./requestServices";
const { feedsApiConfig={} } = appSettings;
const { baseUrl="", subscriptionKey="" } = feedsApiConfig;

export const parseRequestDetails = async (url, opts =  {}) => {
  return {
    url: url,
    method: opts.method || "GET",
    headers: opts.headers || {},
    body: opts.body || null,
    timeout: opts.timeout || null
  };
};

export const parseResponseDetails = async (response) => {
  const body = await response.text().then(text => text).catch(() => null);
  return {
    ok: response.ok,
    headers: response.headers,
    body: body,
    status: response.status,
    statusText: response.statusText,
    type: response.type
  }
}

export const serviceError = (message, requestDetails, responseDetails) => {
  const err = new Error(message);

  if (requestDetails) {
    err.request = requestDetails;
  }

  if (responseDetails) {
    err.response = responseDetails;
  }

  return err;
}

export const parseResponseError = async (resp, message = "Invalid service response") => {
  const getString = str => typeof str === "string" ? str : ""
  const serviceError = await resp.json()
    .then(json => {
      return getString(json.message || json.Message) || getString(json) || json;
    })
    .catch(() => {
      return resp.text()
    });

  const results = serviceError || message;
  return results;
}

export const feedsDataValidation = (respData) => {
  return !!respData && !!respData.length && !!respData[0].data && (typeof respData[0].cardId !== "undefined");
};

export async function listFeedsUnauth(feedIds) {
  const requestUrl = `${baseUrl}/cards?feedIds=${feedIds}`;
  const requestOpts = {
    method: "GET",
    timeout: 30 * 1000,
    headers: {
      "Ocp-Apim-Subscription-Key": subscriptionKey,
      "Content-Type": "application/json"
    }
  };

  try {
    const resp = await fetchRequest(requestUrl, requestOpts);

    const [requestDetails, responseDetails] = await Promise.all([
      parseRequestDetails(requestUrl, requestOpts),
      parseResponseDetails(resp.clone())
    ]);

    if (!resp.ok) {
      throw serviceError(await parseResponseError(resp.clone()), requestDetails, responseDetails);
    }

    const respData = await resp.json().catch(err => {
      throw serviceError(err.message);
    });

    if (!feedsDataValidation(respData)) {
      throw serviceError("Invalid service data", requestDetails, responseDetails);
    }

    return respData;
  } catch (err) {
    return Promise.reject(err);
  }
}

export async function getAuthCreds() {
  try {
    const { claims, token } = await servicesClient.getAuth0Token();
    const supporterNumber = claims["https://worldvision.org/supporter_number"];

    return { token, supporterNumber };
  } catch (err) {
    // TODO: Log auth call failed
    return null;
  }
}

export async function listFeeds(feedIds) {
  let token, supporterNumber;

  try {
    const result = await getAuthCreds();
    token = result.token;
    supporterNumber = result.supporterNumber;
  } catch {
    // Auth failed - no need to log
  }

  if (!token || !supporterNumber) {
    // Fallback to non-auth call here
    return listFeedsUnauth(feedIds);
  }

  const requestUrl = `${baseUrl}/supporters/${supporterNumber}/cards?feedIds=${feedIds}`;
  const requestOpts = {
    method: "GET",
    timeout: 30 * 1000,
    headers: {
      "Ocp-Apim-Subscription-Key": subscriptionKey,
      "Content-Type": "application/json",
      "Authorization" : `Bearer ${token}`
    }
  };

  try {
    const resp = await fetchRequest(requestUrl, requestOpts);

    const [requestDetails, responseDetails] = await Promise.all([
      parseRequestDetails(requestUrl, requestOpts),
      parseResponseDetails(resp.clone())
    ]);

    if (!resp.ok) {
      throw serviceError(await parseResponseError(resp.clone()), requestDetails, responseDetails);
    }

    const respData = await resp.json().catch(err => {
      throw serviceError(err.message);
    });

    if (!feedsDataValidation(respData)) {
      throw serviceError("Invalid service data", requestDetails, responseDetails);
    }

    return respData;
  } catch (err) {
    return Promise.reject(err);
  }
}

